/* eslint-disable max-len */
/* eslint-disable react/display-name */
import React, { useCallback, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { telemetry } from '../../../@vendor/Posthog';
import { LFC } from '../../../Legacy';
import { Popup, PopupProps } from '../../popups/Popup';
import { Prompt } from './../../../ui';
import { TabularData, TabularImportParams, TabularImportStrategy } from './TabularImportModel';
import { TabularImportStepSequence } from './TabularImportStepSequence';
import { TabularImportStrategySelectMenu } from './TabularImportStrategySelectMenu';

export const tabularImportPopup = (data: TabularData, initialParams?: TabularImportParams) =>
    ({ ui: TabularImportPopup, args: { data, initialParams } });

export const TabularImportPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {

    const data = args.data as TabularData;
    const initialParams = args.initialParams as TabularImportParams;
    const [strategy, setStrategy] = useState(null as TabularImportStrategy);

    const onComplete = useCallback((params: TabularImportParams) => {
        action({ strategy, params });
        telemetry.emit('import.apply');
    }, [strategy, action]);

    const onBack = () => setStrategy(null);
    const onCancel = useCallback(() => {
        telemetry.emit('import.cancel');
        dismiss();
    }, [dismiss]);

    useEffectOnce(() => telemetry.emit('import.view'));

    return <Prompt ignoreEnter onAction={onCancel}>
        <Popup w={64} h={48}>
            <Popup.Close onAction={onCancel} />
            <Popup.Title>Import Data</Popup.Title>
            {!strategy
                ? <TabularImportStrategySelectMenu data={data} initialParams={initialParams} onSelect={setStrategy} onCancel={onCancel} />
                : <TabularImportStepSequence data={data} initialParams={initialParams} strategy={strategy} onComplete={onComplete} onCancel={onBack} />}
        </Popup>
    </Prompt>;
};
